import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcLaboratory = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={52}
    height={52}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52 52"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <rect fill="#EEF4FF" width={52} height={52} rx={4} />
      <path
        d="M31.3 42.996c1.704 0 3.093-.922 3.12-2.626v-1.34a.67.67 0 0 1 .65-.64h3.5a1 1 0 0 0 1-1s0 2.3-2.67 4.31c-1.601 1.165-3.53 1.351-5.51 1.356l-.09-.06Z"
        fill="#5590FF"
        fillRule="nonzero"
        opacity={0.598}
      />
      <path
        d="M13.59 9a1.08 1.08 0 0 0-1.09 1.08v31.836a1.08 1.08 0 0 0 1.09 1.08h17.72a3.12 3.12 0 0 0 3.12-3.07v-1.33a.65.65 0 0 1 .65-.64h3.5a1 1 0 0 0 1-1V10.08A1.08 1.08 0 0 0 38.49 9h-24.9Z"
        stroke="#5590FF"
        fill="#D4E4FF"
        fillRule="nonzero"
        strokeLinejoin="round"
      />
      <path
        d="M26.006 31h-.446c-1.186-.169-2.206-.899-2.717-1.945a3.352 3.352 0 0 1 .171-3.26l2.821-4.648a.304.304 0 0 1 .263-.147c.108 0 .208.056.262.147l2.69 4.648c.571.999.6 2.204.077 3.227-.523 1.023-1.533 1.733-2.701 1.902l-.42.076Z"
        stroke="#5590FF"
      />
      <path
        d="M39.57 37.037s.05 2.625-2.62 4.708c-1.601 1.207-3.55 1.246-5.53 1.25"
        stroke="#5590FF"
        strokeLinecap="round"
      />
      <path
        d="M15.42 14h6-6ZM15.42 20h6l1.15 1.992M36.992 23h-4.85l-1.15 1.992M36.992 30.992h-4.949L30.992 29M15.42 38h9-9ZM15.42 40h5-5Z"
        stroke="#5590FF"
      />
    </g>
  </svg>
);
export default SvgIcLaboratory;
